export default "__VITE_ASSET__BmGXwyth__"